module.exports = __webpack_public_path__ + "static/img/master-bl-ship.d750ed31.svg";